import React from 'react';
import ReactDOM from 'react-dom';
import {
    Progress, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverTitle, PopoverContent, Collapse, Card, CardImg, CardText, CardBlock,
    CardTitle, CardSubtitle, Button
} from 'reactstrap';
import Maps from './maps'

export default class dataItem extends React.Component {
    constructor() {
        super();
        this.state = {
            userInfo: false
        }
    }
    DateToFormattedString(d) {
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return (dd[1] ? dd : "0" + dd[0]) + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + yyyy + "   " + (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    };

    render() {
        if (typeof (this.props.dato) === "object") {
            switch (Object.keys(this.props.dato)[0]) {
                case "lat":
                    return (
                        <td className="text-center" style={{ minWidth: "160px" }}>
                            <div className="small text-muted">
                                <span style={{ cursor: "pointer" }}><a onClick={() => { this.setState({ showModalMap: true }) }}>Ver Mapa</a></span>
                            </div>
                            <Modal isOpen={this.state.showModalMap} toggle={() => { this.setState({ showModalMap: false }) }} className="modal-dialog modal-lg">
                                <ModalHeader toggle={() => { this.setState({ showModalMap: false }) }}>
                                    Ubicacion auditor
                                    <div className="small text-muted">
                                        {this.props.dato.lat + "/" + this.props.dato.lon}
                                    </div>
                                </ModalHeader>
                                <ModalBody>
                                    <Maps lat={this.props.dato.lat} lon={this.props.dato.lon} />
                                </ModalBody>
                            </Modal>
                        </td>
                    )
                case "image":
                    return (
                        <td className="text-center">
                            <div>{this.props.dato.image ? this.props.dato.image : "No disponible"}</div>
                            <div className="small text-muted">
                                {
                                    this.props.dato.image
                                        ?
                                        <span style={{ cursor: "pointer" }}><a onClick={() => this.setState({ showModalImage: true })}>Ver imagen</a></span>
                                        :
                                        ""

                                }
                            </div>
                            <Modal isOpen={this.state.showModalImage} toggle={() => { this.setState({ showModalImage: false }) }} className="modal-dialog modal-lg">
                                <ModalBody>
                                    <Card>
                                        <CardImg id="image" top width="30%" src={this.props.dato.url} alt="Card image cap" />
                                        <CardBlock>
                                            <CardTitle>{this.props.dato.image}</CardTitle>
                                        </CardBlock>
                                    </Card>
                                </ModalBody>
                            </Modal>
                        </td>
                    )
                case "device":
                    var device = new Date(this.props.dato.device);
                    var deviceDate = this.DateToFormattedString(device);
                    var sent = new Date(this.props.dato.sent);
                    var sentDate = this.DateToFormattedString(sent);
                    var server = new Date(this.props.dato.server);
                    var serverDate = this.DateToFormattedString(server);
                    return (
                        <td className="text-center">
                            <div>
                                {deviceDate}
                            </div>
                            <div className="small text-muted" onClick={() => this.setState({ dateInfo: !this.state.dateInfo })} style={{ cursor: "pointer" }} id={"date" + this.props.index}>
                                {!this.state.dateInfo ? "Ver detalles" : "Cerrar"}
                            </div>
                            <Popover placement="bottom"
                                isOpen={this.state.dateInfo} id={"popover" + this.props.index}
                                target={"date" + this.props.index}
                                toggle={() => this.setState({ dateInfo: !this.state.dateInfo })}
                                style={{ borderRadius: "5px" }}
                            >
                                <PopoverTitle>Fechas:</PopoverTitle>
                                <div className="text-justify" style={{ padding: "5px" }}>
                                    <div>
                                        <p><b>Toma de registro: </b>{deviceDate}</p>
                                    </div>
                                    <div>
                                        <p><b>Envio de registro: </b>{sentDate}</p>
                                    </div>
                                    <div>
                                        <p><b>Recepción de registro: </b>{serverDate}</p>
                                    </div>
                                </div>
                            </Popover>
                        </td>
                    )
                case "email":
                    return (
                        <td className="text-center">
                            <div>
                                {this.props.dato.name}
                            </div>
                            <div className="small text-muted" onClick={() => this.setState({ userInfo: !this.state.userInfo })} style={{ cursor: "pointer" }} id={"user" + this.props.index}>
                                {!this.state.userInfo ? "Ver detalles" : "Cerrar"}
                            </div>
                            <Popover placement="bottom" isOpen={this.state.userInfo} id={"popoverUser" + this.props.index} target={"user" + this.props.index} toggle={() => this.setState({ userInfo: !this.state.userInfo })}>
                                <PopoverTitle>Usuario:</PopoverTitle>
                                <div className="text-justify" style={{ padding: "5px" }}>
                                    <div>
                                        <p><b>Nombre: </b>{this.props.dato.name}</p>
                                    </div>
                                    <div>
                                        <p><b>Rut: </b>{this.props.dato.rut}</p>
                                    </div>
                                    <div>
                                        <p><b>Email: </b>{this.props.dato.email}</p>
                                    </div>
                                </div>
                            </Popover>
                        </td>
                    )
                default:
                    break;
            }
        }
        else if (typeof (this.props.dato) === "boolean") {
            return (
                <td className="text-center">
                    <input type="checkbox" className="switch-input" checked={this.props.dato} />
                </td>
            )
        }
        else {
            return (
                <td className="text-center">{this.props.dato}</td>
            )
        }

    }
}


// WEBPACK FOOTER //
// ./src/views/data/dataItem.js